module.exports = __webpack_public_path__ + "img/home-hero.fc2e1b84.png";